import { useApiQuery } from '../../api/useApi';
import type { HousekeepingOverview } from '../../pages/housekeeping/types/housekeeping';
import type { LostFoundDashboardData, MaintenanceDashboardData } from '../../pages/housekeeping/api/useHousekeeping';

/**
 * Les lectures des modules ménage du dashboard mobile (réception).
 *
 * Recopiées et non importées : les hooks du web vivent dans
 * `pages/housekeeping/api/`, que la frontière du socle interdit d'atteindre. Seuls
 * les TYPES en viennent, en `import type`. Mêmes URL et même rythme que le web,
 * via `useApiQuery` comme les indicateurs (`useDashboardKPIs`).
 */

/** Le widget web sonde l'état des chambres toutes les 60 s : la pression du jour bouge vite. */
const SONDAGE_CHAMBRES_MS = 60_000;

/** Pannes et objets trouvés : 5 min, comme le web. */
const SONDAGE_SUIVI_MS = 300_000;

export function useEtatDesChambres() {
    return useApiQuery<HousekeepingOverview>('/housekeeping/stats/overview', {}, {
        refetchInterval: SONDAGE_CHAMBRES_MS,
        refetchIntervalInBackground: false,
    });
}

export function usePannesEnCours() {
    return useApiQuery<MaintenanceDashboardData>('/housekeeping/dashboard/maintenance?period=30', {}, {
        staleTime: 60_000,
        refetchInterval: SONDAGE_SUIVI_MS,
    });
}

export function useObjetsTrouves() {
    return useApiQuery<LostFoundDashboardData>('/housekeeping/dashboard/lost-found?period=30', {}, {
        staleTime: 60_000,
        refetchInterval: SONDAGE_SUIVI_MS,
    });
}
